import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Pagination from "./Pagination"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll, useActions } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useEffect, useState } from "preact/hooks"


export function CategoryBody({ loading, foundProducts }) {
    const [gridMode, setGridMode] = useState(true)
    // const { newSearch } = useActions()

    // useEffect(() => {
    //     if(window.location.href.includes("/collections/vendors")){
    //         let newQuery = window.location.href.split("q=")?.pop().replaceAll("+", " ");
    //         newSearch({ query: newQuery })
    //     }
    // }, [])

    if (loading) return <Loader />
    return (
        foundProducts ? <>
            {window.innerWidth > 859 && <SelectedFilters />}
            <Toolbar gridMode={gridMode} setGridMode={setGridMode} />
            <Products gridMode={gridMode} />
            <Pagination />
        </> : <NoResults />
    )
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
